import { useState, Dispatch, SetStateAction } from 'react';
import { createContainer } from 'unstated-next';
import { toast } from '@/hooks/use-toast';
import API from '../api';

import { Body } from '../api/export-report';

export interface IExportReportState {
  reportId?: string;
  reportPdfURL: string;
  loading: boolean;
}

export type ExportReportHookType = {
  state: IExportReportState;
  setState: Dispatch<SetStateAction<IExportReportState>>;
  downloadReport: (body: Body) => Promise<void>;
};

const initialState: IExportReportState = {
  reportId: '',
  reportPdfURL: '',
  loading: false,
};

/**
 *
 * @description: The custom hook used to make API call to export the report
 *
 */

export function useExportReportHook(): ExportReportHookType {
  const [state, setState] = useState(initialState);

  const downloadReport = async (body: Body): Promise<void> => {
    try {
      setState({ reportPdfURL: '', loading: true });
      const reportData = await API.exportReport.post(body);
      setState({
        reportId: reportData.id,
        reportPdfURL: reportData.url,
        loading: false,
      });
      window.open(reportData.url, '_self');
      toast({
        variant: 'success',
        title: 'Exported Report Successfully.',
      });
    } catch (error) {
      const notification = error.message;

      toast({
        variant: 'destructive',
        title: notification,
      });

      setState(prevState => ({ ...prevState, loading: false }));
    }
  };

  return { state, setState, downloadReport };
}

const ExportReportContainer = createContainer(useExportReportHook);

export default ExportReportContainer;
